import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getDocumentCalibrationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "DocumentCalibration", ...action.payload }),
		);
		yield put({
			type: types.GET_DOCUMENTCALIBRATION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_DOCUMENTCALIBRATION_ERROR,
			payload,
		});
	}
}

export function* getDocumentCalibrationWatcherSaga() {
	yield takeLatest(types.GET_DOCUMENTCALIBRATION_START, getDocumentCalibrationHandlerSaga);
}

//create

//delete

function* deleteDocumentCalibrationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("DocumentCalibration", action.payload),
		);
		yield put({
			type: types.DELETE_DOCUMENTCALIBRATION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_DOCUMENTCALIBRATION_ERROR,
			payload,
		});
	}
}

export function* deleteDocumentCalibrationWatcherSaga() {
	yield takeLatest(
		types.DELETE_DOCUMENTCALIBRATION_START,
		deleteDocumentCalibrationHandlerSaga,
	);
}

//update
